import React, { useEffect } from "react";
import { Modal, Paper, Button, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Import CSS
import "components/pages/transmissions/modal/download/DownloadModal.css";
import LoadingSpinner from "components/LoadingSpinner";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleModal,
  toggleProcessing,
} from "app/store/transmission/slice/transmissionSlice";
import { useBulkDownloadMutation } from "app/store/transmission/api/transmissionTableApi";
import { showErrorToast, showSuccessToast } from "utils/toast";

const DownloadModal = () => {
  const { totalSelectedRows, selectedReports, isDownloadModal, isProcessing } =
    useSelector((state) => state.transmission);
  const dispatch = useDispatch();
  const [bulkDownload, { isSuccess, isError, error, data }] =
    useBulkDownloadMutation();

  const onConfirm = () => {
    dispatch(toggleProcessing(true));
    bulkDownload(selectedReports);
  };

  const onClose = () => {
    dispatch(toggleProcessing(false));
    dispatch(toggleModal({ type: "download", value: false }));
  };

  useEffect(() => {
    if (isError && error) {
      showErrorToast("Could not find report for one of the reports");
    }
    if (isSuccess || isError) {
      dispatch(toggleProcessing(false));
      dispatch(toggleModal({ type: "download", value: false }));
    }
    isSuccess && showSuccessToast("Download complete");
  }, [data, error]);

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={isDownloadModal}
        onClose={onClose}
      >
        <div className="process-modal__container">
          <Paper>
            <div className="process-modal__wrapper">
              <Tooltip title="Close" placement="bottom">
                <div onClick={onClose} className="process-modal__close">
                  <CloseIcon />
                </div>
              </Tooltip>
              <div className="process-modal__text">
                {!isProcessing && (
                  <div>
                    {totalSelectedRows === 1 && (
                      <div>Are you sure you want to download this record?</div>
                    )}
                    {totalSelectedRows > 1 && (
                      <div>
                        Are you sure you want to download these{" "}
                        {totalSelectedRows} records?
                      </div>
                    )}
                  </div>
                )}
                {isProcessing && (
                  <div>
                    <div className="process-modal__processing">
                      Downloading {totalSelectedRows}{" "}
                      {totalSelectedRows > 1 ? "reports" : "report"}.
                    </div>
                    <div className="process-modal__spinner">
                      <LoadingSpinner color="secondary" />
                    </div>
                  </div>
                )}
              </div>
              <div className="process-modal__buttons">
                <Button
                  style={{ minWidth: "100px" }}
                  variant="contained"
                  color="secondary"
                  onClick={onConfirm}
                  disabled={isProcessing}
                >
                  Download
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={onClose}
                  disabled={isProcessing}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </Modal>
    </div>
  );
};

export default DownloadModal;
